import { ENVIRONMENT } from '@updater-core/lib/environment';
import { loadAnalyticsJsFromWindow } from './segment';

if (typeof window !== 'undefined') {
  const load = loadAnalyticsJsFromWindow(window);
  const segmentWriteKey = ENVIRONMENT?.keys?.segment;
  const isIE11 = /Trident.*rv[ :]*11\./.test(navigator.userAgent);

  if (segmentWriteKey) {
    load(ENVIRONMENT.keys.segment, {
      integrations: {
        // TODO: FullStory + WebComppnents Polyfill + IE11 = unresponsive.
        // Disable FullStory for IE11 only. [ch16374] [ch22988]
        FullStory: !isIE11,
      },
    });
  }
}
